import { render, staticRenderFns } from "./feedbackDetail.vue?vue&type=template&id=1b869824&scoped=true"
import script from "./feedbackDetail.vue?vue&type=script&lang=js"
export * from "./feedbackDetail.vue?vue&type=script&lang=js"
import style0 from "./feedbackDetail.vue?vue&type=style&index=0&id=1b869824&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b869824",
  null
  
)

export default component.exports